/* looping videos: load near the screen, play only while visible, restart if the browser pauses or freezes them,
   reload after network errors, animated WebP fallback when autoplay is blocked (iOS Low Power Mode / data saver) */
(function(){
  var boxes=[].slice.call(document.querySelectorAll('.media[data-loop]')), blocked=false;
  function fallback(m){
    if(m._fb) return; m._fb=1;
    var a=m.getAttribute('data-anim'), img=m.querySelector('img'), v=m._v||m.querySelector('video');
    if(v){ try{ v.pause(); v.removeAttribute('src'); v.load(); }catch(_){} v.style.display='none'; }   /* stop the MP4 download */
    if(!a||!img) return;
    var pre=new Image(); pre.onload=function(){ img.src=a; }; pre.src=a;
  }
  function blockAll(){ if(blocked) return; blocked=true; boxes.forEach(function(m){ if(m._vis) fallback(m); }); }
  function kick(m){
    var v=m._v; if(!v||m._fb) return;
    if(blocked){ fallback(m); return; }
    var p; try{ p=v.play(); }catch(e){ p=null; }
    if(p&&p.then) p.then(function(){ m._fails=0; },function(e){
      if(!e||e.name==='AbortError') return;                      /* our own pause() interrupted it: harmless */
      if(e.name==='NotAllowedError'){ blockAll(); fallback(m); return; }
      if(++m._fails>=3) fallback(m);                             /* any other repeated failure */
    });
  }
  function recover(m){                                           /* reload the file after a network/decode error */
    var v=m._v; if(!v||m._fb||m._rec) return; m._rec=1;
    var at=v.currentTime||0, n=m._err=(m._err||0)+1, wait=Math.min(8000,500*Math.pow(2,n-1));
    setTimeout(function(){
      m._rec=0; if(m._fb) return;
      v.src=m.getAttribute('data-video'); v.load();
      v.addEventListener('loadedmetadata',function(){ try{ v.currentTime=at%(v.duration||5); }catch(_){} },{once:true});
      if(m._vis) kick(m);
    },wait);
  }
  function load(m){
    if(m._v) return m._v;
    var img=m.querySelector('img'), v=m.querySelector('video'), inline=!!v;
    if(!v) v=document.createElement('video');
    m._v=v; m._last=-1; m._stuck=0; m._fails=0;
    if(blocked){ fallback(m); return v; }
    v.muted=true; v.defaultMuted=true; v.loop=true; v.autoplay=true; v.playsInline=true;
    ['muted','loop','autoplay','playsinline','webkit-playsinline','disablepictureinpicture'].forEach(function(k){ v.setAttribute(k,''); });
    v.preload='auto';
    v.addEventListener('playing',function(){ v.style.opacity='1'; m._err=0; m._stuck=0; });
    v.addEventListener('ended',function(){ v.currentTime=0; if(m._vis) kick(m); });
    v.addEventListener('pause',function(){ if(m._vis&&!document.hidden) setTimeout(function(){ if(m._vis&&v.paused) kick(m); },250); });
    v.addEventListener('error',function(){ recover(m); });
    if(!inline){ v.poster=img.getAttribute('src'); v.src=m.getAttribute('data-video'); v.style.opacity='0'; v.style.transition='opacity .25s'; m.appendChild(v); v.load(); }
    return v;
  }
  function refresh(){                                            /* after tab switch / page freeze: re-sync the picture */
    boxes.forEach(function(m){ var v=m._v; if(!m._vis||!v||m._fb) return; if(v.error||v.networkState===3) recover(m); else { try{ v.pause(); }catch(_){} kick(m); } });
  }
  if(!('IntersectionObserver' in window)){ boxes.forEach(function(m){ m._vis=true; load(m); kick(m); }); return; }
  /* 1 · start downloading well before the box is on screen */
  var near=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ load(e.target); near.unobserve(e.target); } }); },{rootMargin:'1200px 0px'});
  /* 2 · play while visible, pause when gone (fires again every time it comes back) */
  var seen=new IntersectionObserver(function(es){ es.forEach(function(e){
    var m=e.target; m._vis=e.isIntersecting;
    if(m._vis){ load(m); kick(m); } else if(m._v&&!m._v.paused){ m._v.pause(); }
  }); },{threshold:0.15});
  boxes.forEach(function(m){ seen.observe(m); });
  /* the hero loop gets the bandwidth first; the others start downloading once it plays (or after 2.5 s) */
  var started=0; function startNear(){ if(started) return; started=1; boxes.forEach(function(m){ near.observe(m); }); }
  var hero=boxes[0]&&boxes[0].querySelector('video');
  if(hero&&!(hero.currentTime>0)){ hero.addEventListener('playing',startNear,{once:true}); setTimeout(startNear,2500); } else startNear();
  /* 3 · watchdog: a visible video that is paused, frozen or dead gets restarted / reloaded */
  setInterval(function(){
    if(document.hidden) return;
    boxes.forEach(function(m){
      var v=m._v; if(!m._vis||!v||m._fb) return;
      if(v.error||v.networkState===3){ recover(m); return; }
      if(v.paused){ kick(m); return; }
      if(v.currentTime===m._last){
        m._stuck++;
        if(v.readyState>=2&&m._stuck>=2){ m._stuck=0; try{ v.currentTime=(v.currentTime+0.05)%(v.duration||5); }catch(_){} kick(m); }
        else if(m._stuck>=6){ m._stuck=0; recover(m); }      /* no data for ~9 s: reload */
      } else m._stuck=0;
      m._last=v.currentTime;
    });
  },1500);
  document.addEventListener('visibilitychange',function(){ if(!document.hidden) refresh(); });
  document.addEventListener('resume',refresh);
  window.addEventListener('pageshow',refresh);
  window.addEventListener('online',function(){ boxes.forEach(function(m){ if(m._v&&!m._fb){ m._err=0; if(m._v.error||m._v.readyState<2) recover(m); } }); });
})();
/* gallery dots */
(function(){var s=document.getElementById('slider'),d=document.querySelectorAll('#dots i');
 s.addEventListener('scroll',function(){var i=Math.round(s.scrollLeft/s.clientWidth);d.forEach(function(x,k){x.classList.toggle('on',k===i)})},{passive:true});})();